import { UIElements } from '@ansvar-sakerhet/ui';
import { styled } from 'styled-components';

const Button = styled(UIElements.Button)`
  height: auto;
`;

export const S = { ...UIElements, Button };
